export default [{
    id: "04001",
    name: "Medizinische Universitat Wien",
},{
    id: "04002",
    name: "Medizinische Universität Graz",
}, ];